/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GuangGaoTongJiChaXun,
  ResponseApiGuangGaoTongJiShouYeShuJu,
  ResponseApiGuangGaoTongJiTuiGuangXiTongShuJu,
  ResponseApiOperationHomeRespDTO,
  ResponseApiPageAccountingHomeRespDTO,
  YunYingHouTaiShouYeChaXunTiaoJian,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class BaoBiaoTongJiShuJu<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags BaoBiaoTongJiShuJu
   * @name AdStatDataToCampaignUsingPost
   * @summary 广告主广告数据统计用于Campaign列表
   * @request POST:/dsp-admin/api/stat/adStatDataToCampaign
   * @secure
   */
  adStatDataToCampaignUsingPost = (
    queryDTO: GuangGaoTongJiChaXun,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiGuangGaoTongJiTuiGuangXiTongShuJu, void>({
      path: `/dsp-admin/api/stat/adStatDataToCampaign`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags BaoBiaoTongJiShuJu
   * @name HomeStatDataUsingPost
   * @summary 广告主首页广告统计数据
   * @request POST:/dsp-admin/api/stat/homeAdStatData
   * @secure
   */
  homeStatDataUsingPost = (
    queryDTO: GuangGaoTongJiChaXun,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiGuangGaoTongJiShouYeShuJu, void>({
      path: `/dsp-admin/api/stat/homeAdStatData`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags BaoBiaoTongJiShuJu
   * @name OperationHomeDataUsingPost
   * @summary 运营后台首页数据
   * @request POST:/dsp-admin/api/stat/operationHomeData
   * @secure
   */
  operationHomeDataUsingPost = (
    queryDTO: YunYingHouTaiShouYeChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiOperationHomeRespDTO, void>({
      path: `/dsp-admin/api/stat/operationHomeData`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags BaoBiaoTongJiShuJu
   * @name AccountDataCenterUsingPost
   * @summary 运营后台数据中心(大盘概览)
   * @request POST:/dsp-admin/api/stat/operationOverviewData
   * @secure
   */
  accountDataCenterUsingPost = (
    queryDTO: GuangGaoTongJiChaXun,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiPageAccountingHomeRespDTO, void>({
      path: `/dsp-admin/api/stat/operationOverviewData`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new BaoBiaoTongJiShuJu();
